(() => {
	const INIT_CLASS = 'brand-list-swiper-initialized';
	const MIN_LOOP_SLIDES = 10;

	const parseSpeed = (el) => {
		const duration = parseFloat(el.getAttribute('data-duration'));
		return Number.isFinite(duration) && duration > 0 ? duration * 1000 : 5000;
	};

	const duplicateSlidesForLoop = (wrapper) => {
		const originals = [
			...wrapper.querySelectorAll('.swiper-slide:not([data-brand-clone])'),
		];
		if (originals.length === 0) return 0;

		wrapper
			.querySelectorAll('.swiper-slide[data-brand-clone]')
			.forEach((clone) => clone.remove());

		let total = originals.length;
		while (total < MIN_LOOP_SLIDES) {
			originals.forEach((slide) => {
				const clone = slide.cloneNode(true);
				clone.setAttribute('data-brand-clone', '');
				clone.removeAttribute('data-shopify-editor-block');
				wrapper.appendChild(clone);
			});
			total += originals.length;
		}

		return originals.length;
	};

	const destroyBrandSlider = (el) => {
		if (el.swiper) {
			el.swiper.destroy(true, true);
		}

		el.querySelectorAll('.swiper-slide[data-brand-clone]').forEach((clone) => {
			clone.remove();
		});

		el.classList.remove(INIT_CLASS);
	};

	const initBrandSlider = (root = document) => {
		root.querySelectorAll('.brand-list.swiper').forEach((el) => {
			const wrapper = el.querySelector('.swiper-wrapper');
			if (!wrapper) return;

			destroyBrandSlider(el);

			const slideCount = duplicateSlidesForLoop(wrapper);
			if (slideCount < 2) return;

			const swiper = new Swiper(el, {
				slidesPerView: 'auto',
				spaceBetween: 0,
				loop: true,
				loopAdditionalSlides: slideCount,
				speed: parseSpeed(el),
				allowTouchMove: false,
				watchOverflow: false,
				autoplay: {
					delay: 0,
					disableOnInteraction: false,
					pauseOnMouseEnter: false,
				},
				on: {
					init(instance) {
						instance.autoplay.start();
					},
				},
			});

			el.classList.add(INIT_CLASS);
			el.brandSwiper = swiper;
		});
	};

	document.addEventListener('DOMContentLoaded', () => {
		initBrandSlider();
	});

	document.addEventListener('shopify:section:load', (event) => {
		initBrandSlider(event.target);
	});

	document.addEventListener('shopify:section:unload', (event) => {
		event.target.querySelectorAll('.brand-list.swiper').forEach(destroyBrandSlider);
	});
})();
